import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IRunningConfigOnu } from '@modules/clients/services/olt/models/onus.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-show-running-config-onu',
  standalone: true,
  imports: [],
  templateUrl: './show-running-config-onu.component.html',
})
export class ShowRunningConfigOnuComponent implements OnInit {
  public runningConfig!: IRunningConfigOnu;
  constructor(
    public readonly dynamicDialogRef: DynamicDialogRef,
    public readonly dynamicDialogConfig: DynamicDialogConfig<{ sn: string; runningConfig: IRunningConfigOnu } | null>,
    private sanitizer: DomSanitizer,
  ) {}
  ngOnInit(): void {
    if (this.dynamicDialogConfig.data?.sn) {
      const sn = this.dynamicDialogConfig.data.sn;
      this.getRunningConfigOnu(sn);
    }
  }

  /**
   * getRunningConfigOnu
   */
  public async getRunningConfigOnu(sn: string): Promise<void> {
    if (this.dynamicDialogConfig.data) {
      this.runningConfig = this.dynamicDialogConfig.data?.runningConfig;
    }
  }

  public sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html.replace(/\n/g, '<br>'));
  }
}
